// service request
import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity,} from "react-native";
import { getServiceReq } from "../../api/serviceRequest";
import CImage from "../../common/CImage";
import * as RootNavigation from "../../utilities/RootNavigation";
import { getAllVehiclesListApi } from "../../api/apiManager";
import useStyles from "./index_SR_Styles";
import Loader from "../../common/Loader";

export default function ServiceRequest(props) {
  const styles = useStyles();
  const [searchText, setSearchText] = useState("");
  const [dataArr, setDataArr] = useState([]);
  const [vehicleList, setVehicleList] = useState([])
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({})

  const ServiceRequestCard = ({ backgroundImage = backgroundImage, backgroundColor: backgroundColor, title = "Change mobile number", icon = <CImage.SrUpdateMobileIcon />, onPress }) => {
    return (
      <TouchableOpacity onPress={onPress} style={{ marginRight: 10 }}>
        <View
          style={[styles.srCard,{
            borderRadius: 12,
            backgroundImage: backgroundImage,
            backgroundColor: backgroundColor,
          }]}
        >
          {icon}
          <Text style={styles.srCardText}>{title}</Text>
        </View>
      </TouchableOpacity>

    );
  }
  const geAllVehicle = () => {
    
      setLoading(true);  
      getAllVehiclesListApi()
        .then((res) => {
          setVehicleList(res)
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
           }); ;
  }


  useEffect(() => {
    geAllVehicle();
  }, []);

  const vehicleData = () => {
    
    getServiceReq()
      .then((response) => {
        if (response?.data) {
          setData({ getServiceRequests: response.data });
          if (response.data.length) {
            let records = response.data.filter(
              (item) => item?.requestType == "KYC Update"
            );
          }
          setDataArr(response.data);
        } else {
          setData({ getServiceRequests: [] });
        }
      })
      .catch(() => { });
  };


  const filterData = () => {
    let tempArr = dataArr?.filter((item) => {
      return item.serReqId.includes(searchText);
    });
    setData({ getServiceRequests: tempArr });
  };

  useEffect(() => {
    if (searchText && searchText.length > 2) {
      filterData();
    } else if ((searchText && searchText.length < 2) || searchText == "") {
      vehicleData();
    }
  }, [searchText]);



  return (
    <View>
      {loading && <Loader />}
      <View style={styles.headerWidget}>
        <View style={styles.SvcRq_Body_row1_headingTextHelper}>
          <Text style={styles.SvcRq_Body_row1_headingText}>
            {'Create New  \n Service Request'}
          </Text>
        </View>
      </View>
      <View style={styles.cardWrapper}>
        <ServiceRequestCard
          backgroundImage={"linear-gradient(172deg, rgba(216,117,133,1) 43%, rgba(167,35,57,1) 95%)"}
          title="Change mobile number"
          icon={<CImage.SrUpdateMobileIcon />}
        onPress={() => RootNavigation.navigate("ServiceRequest/MobileUpdate")}
        />
        <ServiceRequestCard
          backgroundImage={"linear-gradient(172deg, rgba(110,58,79,1) 43%, rgba(51,15,30,1) 95%)"}
          title="Update KYC"
          icon={<CImage.SrUpdateKycIcon />}
        onPress={() => RootNavigation.navigate("ServiceRequest/KycUpdate")}
        />
        <ServiceRequestCard
          backgroundImage={"linear-gradient(172deg, rgba(90,157,214,1) 43%, rgba(6,102,151,1) 95%)"}
          title="Update Vehicle no."
          icon={<CImage.SrUpdateVehicleIcon />}
        onPress={() => RootNavigation.navigate("ServiceRequest/RcUpdate")}
        />
        <ServiceRequestCard
          backgroundImage={"linear-gradient(172deg, rgba(218,110,74,1) 43%, rgba(155,47,32,1) 95%)"}
          title="Close your Fastag"
          icon={<CImage.SrCloseTagIcon />}
        onPress={() => RootNavigation.navigate("ServiceRequest/SelectVehicleForTagClosure")}
        />
        <ServiceRequestCard
          backgroundImage={"linear-gradient(172deg, rgba(182,181,155,1) 43%, rgba(108,105,92,1) 95%)"}
          title="My Disputes"
          icon={<CImage.SrDisputesIcon />}
        onPress={() => RootNavigation.navigate("Dispute")}
        />
        <ServiceRequestCard 
          backgroundImage={"linear-gradient(135deg, rgba(177, 160, 89, 1) 43%, rgba(134, 108, 32, 1) 95%)"}
          title="Update KYV"
          icon={<CImage.SrUpdateKYVIcon />}
        onPress={() => {
          if(vehicleList?.length >1){
            RootNavigation.navigate("Profile/MyVehicles")
          }else{
            RootNavigation.navigate("Profile/MyVehicles/UpdateKYV",{backNavigation:"ServiceRequest",vrn:vehicleList[0].vrn})
          }
          }}
        />
      </View>

    </View>
  );
}

